const getters = {
  user: (state) => state.userInfo.profile,
  isAuthenticated: (state, getters) => {
    return getters.user && !!getters.user.user_id;
  },
};
export default getters;
